var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceGeneral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#1F76FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15771 7.58039C6.15948 6.01147 7.4309 4.74004 8.99982 4.73828C10.5687 4.74004 11.8402 6.01147 11.8419 7.58039C11.8419 8.82878 10.0656 11.8528 9.3025 13.0951C9.23837 13.2009 9.12347 13.2652 8.99982 13.2646C8.8764 13.2646 8.76181 13.2006 8.69714 13.0955C7.93403 11.8524 6.15771 8.82736 6.15771 7.58039ZM7.7564 7.58039C7.7564 8.26711 8.3131 8.82381 8.99982 8.82381C9.68654 8.82381 10.2432 8.26711 10.2432 7.58039C10.2432 6.89366 9.68654 6.33697 8.99982 6.33697C8.3131 6.33697 7.7564 6.89366 7.7564 7.58039Z",
    fill: "#F4F4F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceGeneral);
export default __webpack_public_path__ + "static/media/PlaceGeneral.a4741940ae577bf7fd5e560451a8f144.svg";
export { ForwardRef as ReactComponent };